<form [formGroup]="form()">
    <div class="grid grid-cols-1 gap-4">
            <spike-field-text 
                formControlName="shortDescription" 
                label="Titolo Portafoglio" 
                placeholder="Es: Conto Corrente Principale">
            </spike-field-text>

        <spike-field-date 
            formControlName="startDate" 
            label="Data Inizio" 
            placeholder="Seleziona data">
        </spike-field-date>

        <spike-field-number 
            formControlName="base" 
            label="Saldo Iniziale" 
            placeholder="0.00">
        </spike-field-number>

        <spike-field-text-area 
            formControlName="description" 
            label="Note" 
            placeholder="Aggiungi ulteriori dettagli sul portafoglio...">
        </spike-field-text-area>
    </div   >
</form>